<style>
.el-collapse-item__header {
  padding-left: 15px;
}
.el-upload--picture-card {
  float: left;
  margin-right: 10px;
}
.circle-closesty {
  position: relative;
  top: -35px;
  margin-left: 112px;
  font-size: 20px;
  cursor: pointer;
}
.v-modal {
  z-index: 100 !important;
}
.select-box {
  overflow: hidden;
  margin: 0 0px 10px 30px;
}
.box-left {
  width: 40%;
  height: 350px;
  padding: 0 20px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
  overflow-y: auto;
}
.box-right {
  width: 57%;
  height: 350px;
  padding: 0 10px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
}
</style>
<template>
  <div class="content">
    <div class="search-area">
      <el-row :gutter="16">
        <el-col :span="8">
          <div class="search-area-div">类型：</div>
          <el-select v-model="page.enterpriseType" placeholder="请选择类型" class="ipt-sty">
            <el-option v-for="item in enterpriseCateList" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="8"
          ><div class="search-area-div">公司名称：</div>
          <el-input v-model="page.tenantName" class="ipt-sty" placeholder="请输入公司名称"></el-input
        ></el-col>
      </el-row>
      <div style="padding: 20px 20px 0 0; text-align: right">
        <el-button size="medium" type="info" @click="search">搜索</el-button>
        <el-button size="medium" type="danger" @click="emptySearch">清空</el-button>
      </div>
    </div>

    <div class="button-area">
      <el-button icon="el-icon-plus" size="medium" type="info" @click="addVersion">新增公司</el-button>
    </div>
    <div class="back-color-fff p16">
      <el-table :data="tableData" border style="width: 100%" v-loading="tableLoading" :height="height">
        <el-table-column label="序号" width="60" header-align="center" align="center" fixed="center">
          <template slot-scope="scope">
            <!-- {{ scope.$index + 1 }} -->
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="enterpriseCate" label="类型" header-align="center" align="center">
          <template slot-scope="scope">{{ getenterpriseCateName(scope.row.enterpriseCate) }}</template>
        </el-table-column>

        <el-table-column prop="tenantName" show-overflow-tooltip label="公司名称" header-align="center" align="center">
          <template slot-scope="scope">{{ scope.row.tenantName }}</template>
        </el-table-column>

        <el-table-column prop="quota" label="限额" header-align="center" align="center">
          <template slot-scope="scope">{{
            scope.row.quota == '0' ? '不限额' : scope.row.quota | numDigit | numFmt
          }}</template>
        </el-table-column>
        <el-table-column prop="operator" label="操作人" header-align="center" align="center">
          <template slot-scope="scope">{{ scope.row.operator }}</template>
        </el-table-column>
        <el-table-column prop="operateTime" label="操作时间" header-align="center" align="center">
          <template slot-scope="scope">{{ scope.row.operateTime | getDate }}</template>
        </el-table-column>
        <el-table-column prop="bank" min-width="100px" label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <a class="txt-color" @click="editVersion(scope.row.guid)">编辑 ｜</a>
            <a class="txt-color" @click="delVersion(scope.row.guid)">删除</a>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      class="pt pb back-color-fff"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 100, 200]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination>
    <el-dialog :title="textTitle" :visible.sync="dialogVisible" width="40%">
      <el-form label-width="90px" :label-position="right" class="demo-ruleForm">
        <el-form-item>
          <span slot="label" style="color: red">*</span>
          <span slot="label">公司名称 </span>
          <el-input type="input" :maxlength="50" placeholder="请输入公司名称" v-model="tenantName"> </el-input>
        </el-form-item>
        <el-form-item>
          <span slot="label" style="color: red">*</span>
          <span slot="label">类型 </span>
          <el-select
            v-model="enterpriseCate"
            @change="changeCate"
            placeholder="请选择类型"
            class="fl"
            style="width: 100%"
          >
            <el-option
              v-for="item in enterpriseCateList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="enterpriseCate != '9903'">
          <span slot="label" style="color: red">*</span>
          <span slot="label">限额 </span>
          <el-input
            oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')"
            placeholder="单位（元）"
            v-model="quota"
          >
          </el-input>
        </el-form-item>
        <div v-if="enterpriseCate != '9903'" style="float: left; margin-left: 50px">大写：{{ quota | smallToBig }}</div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" plain @click="dialogVisible = false">取 消</el-button>
        <el-button
          size="medium"
          type="info"
          v-if="textTitle == '新增公司'"
          @click="addReqVersion"
          v-loading.fullscreen.lock="fullscreenLoading"
          >确 定</el-button
        >
        <el-button
          size="medium"
          type="info"
          v-else
          @click="updateReqVersion"
          v-loading.fullscreen.lock="fullscreenLoading"
          >修 改</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { route } from '@/api/apiRoute';
import store from '@/store';
import { Loading } from 'element-ui';
export default {
  data() {
    return {
      fullscreenLoading: false,
      textTitle: '新增公司',
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        tenantName: '',
        enterpriseType: '',
      },
      enterpriseCateList: [
        {
          label: ' 代缴',
          value: '9903',
        },
        {
          label: '代征',
          value: '9904',
        },
        {
          label: '征缴',
          value: '9905',
        },
      ],
      enterpriseCate: '',
      tenantName: '',
      quota: null,
      articleId: '',
      tableLoading: false,

      height: window.innerHeight - 260,
      right: 'right',
      tableData: [],
      dialogVisible: false,
      loadingInstance: null,
    };
  },
  created() {
    this.getList();
  },
  watch: {},
  methods: {
    search() {
      let self = this;
      self.tableLoading = true;
      self.api
        .get(
          `/${serverConfig.msCustomerService}/delegation-company/list?pageIndex=1&pageSize=10&tenantName=${this.page.tenantName}&enterpriseType=${this.page.enterpriseType}`,
        )
        .then((res) => {
          self.tableLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.tableData = res.data.data.records;
            self.page.totalPage = res.data.data.totalPages;
            self.page.totalRows = res.data.data.totalRows;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    emptySearch() {
      this.page = {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        tenantName: '',
        enterpriseCate: '',
      };
      this.getList();
    },
    addVersion() {
      this.textTitle = '新增公司';
      this.enterpriseCate = '';
      this.tenantName = '';
      this.quota = '';
      this.dialogVisible = true;
    },
    editVersion(guid) {
      this.textTitle = '修改公司';
      this.enterpriseCate = '';
      this.tenantName = '';
      this.quota = '';
      this.dialogVisible = true;
      var self = this;
      self.loadingInstance = Loading.service({
        fullscreen: true,
        background: 'rgba(255,255,255,0.1)',
      });
      self.api.get(`/${serverConfig.msCustomerService}/delegation-company/detail/${guid}/`).then((res) => {
        self.loadingInstance.close();
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.enterpriseCate = res.data.data.enterpriseCate;
          this.tenantName = res.data.data.tenantName;
          this.quota = res.data.data.quota;
          this.articleId = guid;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getList() {
      let self = this;
      self.tableLoading = true;
      self.api.get(`/${serverConfig.msCustomerService}/delegation-company/list`, this.page).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    delVersion(guid) {
      var self = this;
      self
        .$confirm('删除后不可恢复，确定删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          self.loadingInstance = Loading.service({
            fullscreen: true,
            background: 'rgba(255,255,255,0.1)',
          });
          self.api.postJson(`/${serverConfig.msCustomerService}/delegation-company/del`, [guid]).then((res) => {
            self.loadingInstance.close();
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.$message.success('删除成功');
              self.page.pageIndex = 1;
              self.getList();
            } else {
              self.$message.error(res.data.msg);
            }
          });
        });
    },
    changeCate() {
      this.quota = '';
    },
    addReqVersion() {
      var self = this;
      if (!this.tenantName) {
        self.$message('请填写公司名称');
        return;
      }
      if (!this.enterpriseCate) {
        self.$message('请选择类型');
        return;
      }
      if (!this.quota && this.enterpriseCate != '9903') {
        self.$message('请填写限额');
        return;
      }
      var req = {
        tenantName: this.tenantName,
        enterpriseCate: this.enterpriseCate,
        quota: this.enterpriseCate == '9903' ? 0 : this.quota,
      };
      self.loadingInstance = Loading.service({
        fullscreen: true,
        background: 'rgba(255,255,255,0.1)',
      });
      self.api.postJson(`/${serverConfig.msCustomerService}/delegation-company/add`, req).then((res) => {
        self.loadingInstance.close();
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.dialogVisible = false;
          self.$message.success('新增成功');
          self.page.pageIndex = 1;
          self.getList();
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    updateReqVersion() {
      var self = this;
      if (!this.tenantName) {
        self.$message('请填写公司名称');
        return;
      }
      if (!this.enterpriseCate) {
        self.$message('请选择类型');
        return;
      }
      if (!this.quota && this.enterpriseCate != '9903') {
        self.$message('请填写限额');
        return;
      }
      var req = {
        tenantName: this.tenantName,
        enterpriseCate: this.enterpriseCate,
        quota: this.enterpriseCate == '9903' ? 0 : this.quota,
        guid: this.articleId,
      };
      self.loadingInstance = Loading.service({
        fullscreen: true,
        background: 'rgba(255,255,255,0.1)',
      });
      self.api.put(`/${serverConfig.msCustomerService}/delegation-company/update`, req).then((res) => {
        self.loadingInstance.close();
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.dialogVisible = false;
          self.$message.success('修改成功');
          self.getList();
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getenterpriseCateName(guid) {
      var enterpriseCateList = this.enterpriseCateList;
      var item = enterpriseCateList.filter((item) => item.value == guid);
      if (item.lenght == 0) return;
      return item[0].label;
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getList();
    },
  },
};
</script> 
<style scoped>
.el-table /deep/ .el-input__inner {
  height: 40px;
  line-height: 40px;
}
.el-range-editor.el-input__inner {
  padding: 0px;
}
/deep/ .el-checkbox__label {
  display: none;
}
.attach-sty {
  width: 170px;
  float: left;
  margin-top: 15px;
  text-align: center;
}
.checkbox-img-sty {
  border: 1px solid #dcdfe6;
  width: 16px;
  height: 16px;
  border-radius: 2px;
  cursor: pointer;
}
/deep/ .el-step__icon.is-text {
  border-radius: 50%;
  border-color: #4fa1a4;
  border-color: inherit;
}
/deep/ .el-step__icon-inner {
  color: #4fa1a4;
}
/deep/ .el-step__title.is-process {
  color: #4fa1a4;
}
</style>